/* eslint-disable id-length */
import api from '#config/api';

export const createAdelphiStatement = values => api.post('/statements', values);

export const getAllAdelphiStatements = () => api.get('/statements');

export const getAdelphiStatementById = ({ id }) => api.get(`/statements/${id}`);

export const generateAdelphiStatementCSVById = ({ id }) => api.post(`/statements/${id}/csv`);

export const deleteAdelphiStatementById = ({ id }) => api.delete(`/statements/${id}`);
